import { GlobalState } from 'src/app/interfaces/store/store.interface';

export const initalState: GlobalState = {
    environment: {},
    organisations: {
        data: [],
        loading: false,
    },
};
